// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".microphone-meter[data-v-6b6bb454] {\n  display: flex;\n}\n.microphone-meter .level-item[data-v-6b6bb454] {\n  background-color: var(--v-date-base);\n  width: 4px;\n  height: 22px;\n  margin-right: 4px;\n  border-radius: 4px;\n}\n.microphone-meter .level-item.active-item[data-v-6b6bb454] {\n  background-color: var(--v-success-base);\n}", ""]);
// Exports
module.exports = exports;
